var lists_default = {
  "fontElementMap": "pDT8q",
  "orderedlist": "erjqb",
  "bulletedlist": "_4ZJKX",
  "listItem": "qUi3b"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
